<template>
  <div style="width:100%">
    <van-tabs v-model:active="active" style="width:100%">
      <van-tab :title="`可使用（${enableDataLenNum}）`">
        <MyPlanListCard :isEnable="true" :datas="enablePlanList" :listStatusFlag="1" @loadData="getEnableData" @viewUseDealer="viewUseDealerFn" @viewContract="viewContractFn" />
        <Loading v-if="isShowLoad1" />
        <van-divider v-if="isShowDivider1" dashed :style="dividerStyle">{{ noDataMsg }}</van-divider>
      </van-tab>
      <van-tab :title="`已使用（${usedDataLenNum}）`">
        <MyPlanListCard :isEnable="true" :datas="usedList" :listStatusFlag="3" @loadData="getUsedData" @viewUseDealer="viewUseDealerFn" @viewContract="viewContractFn" />
        <Loading v-if="isShowLoad2" />
        <van-divider v-if="isShowDivider2" dashed :style="dividerStyle">{{ noDataMsg }}</van-divider>
      </van-tab>
      <van-tab :title="`不可使用（${disableDataLenNum}）`">
        <MyPlanListCard :isEnable="false" :datas="disablePlanList" :listStatusFlag="2" @loadData="getDisableData" @viewUseDealer="viewUseDealerFn" @viewContract="viewContractFn" />
        <Loading v-if="isShowLoad3" />
        <van-divider v-if="isShowDivider3" dashed :style="dividerStyle">{{ noDataMsg }}</van-divider>
      </van-tab>
    </van-tabs>
    <div v-show="false">
      <UseDealer ref="useDealerRef" :isShowPhone="true" :param="applyDealerParam"> </UseDealer>
    </div>
    <ContractServiceDeal :showPopUp="showPopUp" :datas="contractData" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, onUnmounted, computed } from 'vue'
import MyPlanListCard from '@/components/plan/MyPlanListCard.vue'
import Loading from '@/components/common/Loading.vue'
import { getMyPlanList as getMyCouponCard } from '@/api/plan'
import { getCouponReminderStatusApi } from '@/api/offer'
import useDealerFn from '@/util/order/useDealer'
import UseDealer from '@/components/canUseDealer/CurrentDealer'
import { EWCouponType } from '@/util/order/staticConfig'
import useContractServiceDealFn from '@/hooks/directSales/useContractServiceDeal'
import ContractServiceDeal from '@/components/directSales/ContractServiceDeal'
import _ from 'lodash'

export default {
  components: {
    MyPlanListCard,
    Loading,
    UseDealer,
    ContractServiceDeal
  },
  setup() {
    const { applyDealerParam, viewUseDealer, useDealerRef } = useDealerFn()
    const { viewContractServiceDealFn, viewEWContractServiceDealFn, showPopUp, contractData } = useContractServiceDealFn()
    const mountEle = document.createElement('div')
    mountEle.id = 'dialog'
    document.body.appendChild(mountEle)
    // 清空节点
    onUnmounted(() => {
      document.body.removeChild(mountEle)
    })

    const state = reactive({
      dividerStyle: { color: '#999', borderColor: '#bbb', padding: '0 16px' },
      active: 0,
      noDataMsg: '当前状态卡券列表为空',
      // enablePlanList: [],
      // usedList: [],
      // disablePlanList: [],
      isShowLoad1: false,
      isShowLoad2: false,
      isShowLoad3: false,
      applyDealerParam,
      enableData: {},
      usedData: {},
      disableData: {},
      enablePagination: {},
      usedPagination: {},
      disablePagination: {}
    })
    // 可使用
    const enablePlanList = computed(() => state.enableData?.[state.enableData.id] || [])
    const isShowDivider1 = computed(() => !enablePlanList.value?.length && !state.isShowLoad1)
    const enableDataLenNum = computed(() => state.enablePagination?.recordCount || 0)
    const getEnableData = async data => {
      state.isShowLoad1 = true
      let couponType = data?.id || '0'
      state.enableData.id = couponType
      state.enableData[couponType] = []
      try {
        let { list, pagination } = await getMyCouponCard({ statusFlag: 1, couponType })
        // 获取所有卡券是否是临期卡券
        let couponList = await getCouponReminderStatus(list) || list
        // 临期卡券排（isHasReminderCoupon为true）在最前面
        const sortedCouponList = _.orderBy(couponList, [
          item => Number(item.isHasReminderCoupon),
          item => sortCoupon(item),
        ], ['desc', 'asc']);


        state.enableData[couponType] = sortedCouponList
        state.enablePagination = pagination
      } catch (error) {
        console.log(error)
        state.enablePagination = {}
      } finally {
        state.isShowLoad1 = false
      }
    }

    const sortCoupon = coupon => {
      if (coupon.couponType === 101) {
        // 延保
        return new Date(coupon.contractEndDate).getTime();
      } else if (coupon.couponType && coupon.couponType !== 101) {
        // 保养套餐,礼包
        return new Date(coupon.activeEndTime).getTime();
      } else {
        // 致友计划，轮胎套餐:对rightCoupon中的每个项目按activeEndTime从近到远排序,并返回最近一次activeEndTime的时间戳
        if (coupon.rightCoupon && coupon.rightCoupon.length > 0) {
          const sortedRightCoupon = _.orderBy(coupon.rightCoupon, item => new Date(item.activeEndTime).getTime(), ['desc']);
          return new Date(sortedRightCoupon[0].activeEndTime).getTime();
        }
        // 如果rightCoupon数组为空或不存在，返回当前日期时间
        return new Date().getTime();
      }
    }

    // 获取卡券状态：是否临期
    const getCouponReminderStatus = async list => {
      if (list.length > 0) {
        let couponCodesAll = []
        list.forEach(item => {
          if (item.loyaltyId) {
            // 致友计划，轮胎套餐
            item.rightCoupon.forEach(coupon => {
              couponCodesAll.push(coupon.couponCode);
            });
          } else if (item.couponType === 101) {
            // 延保: 后端要求传递 contractCode
            couponCodesAll.push(item.contractCode);
          } else if (item.couponType && item.couponType !== 101) {
            // 保养套餐,礼包
            couponCodesAll.push(item.couponCode);
          }
        });

        try {
          const couponReminderStatusList = await getCouponReminderStatusApi(couponCodesAll) || []
          const reminders = new Map(couponReminderStatusList.map(item => [item.couponCode, item.reminder]));
          // 为原始数据添加isReminder和isHasReminderCoupon属性
          list.forEach(item => {
            if (item.loyaltyId) {
              let hasReminder = false;
              item.rightCoupon.forEach(coupon => {
                coupon.isReminder = reminders.get(coupon.couponCode) || false;
                if (coupon.isReminder) {
                  hasReminder = true;
                }
              });
              // 如果至少一个临期卡券，则设置isHasReminderCoupon为true
              item.isHasReminderCoupon = hasReminder;
            } else if (item.couponType === 101) {
              item.isHasReminderCoupon = reminders.get(item.contractCode) || false;
            } else if (item.couponType && item.couponType !== 101) {
              item.isHasReminderCoupon = reminders.get(item.couponCode) || false;
            }
          });
        } catch (error) {
          console.log(error)
        } finally {
          return list
        }
      }
    }

    // 已使用
    const usedList = computed(() => state.usedData?.[state.usedData.id] || [])
    const isShowDivider2 = computed(() => !usedList.value?.length && !state.isShowLoad2)
    const usedDataLenNum = computed(() => state.usedPagination?.recordCount || 0)
    const getUsedData = async data => {
      // console.log('getUsedData', data)
      state.isShowLoad2 = true
      let couponType = data?.id || '0'
      state.usedData.id = couponType
      state.usedData[couponType] = []
      try {
        let { list, pagination } = await getMyCouponCard({ statusFlag: 3, couponType })
        state.usedData[couponType] = list
        state.usedPagination = pagination
      } catch (error) {
        console.log(error)
        state.usedPagination = {}
      } finally {
        state.isShowLoad2 = false
      }
    }
    // 不可使用
    const disablePlanList = computed(() => state.disableData?.[state.disableData.id] || [])
    const isShowDivider3 = computed(() => !disablePlanList.value?.length && !state.isShowLoad3)
    const disableDataLenNum = computed(() => state.disablePagination?.recordCount || 0)
    const getDisableData = async data => {
      // console.log('getDisableData', data)
      state.isShowLoad3 = true
      let couponType = data?.id || '0'
      state.disableData.id = couponType
      state.disableData[couponType] = []
      try {
        let { list, pagination } = await getMyCouponCard({ statusFlag: 2, couponType })
        state.disableData[couponType] = list
        state.disablePagination = pagination
      } catch (error) {
        console.log(error)
        state.disablePagination = {}
      } finally {
        state.isShowLoad3 = false
      }
    }
    onMounted(async () => {
      state.isShowLoad1 = true
      try {
        // let { list } = await getMyCouponCard()
        // state.enablePlanList = list.filter(item => item.statusFlag === 1)
        // state.disablePlanList = list.filter(item => item.statusFlag === 2)
        // state.usedList = list.filter(item => item.statusFlag === 3)
        let allOPOtion = { label: '全部', id: '0', val: 'all' }
        getEnableData(allOPOtion)
        getUsedData(allOPOtion)
        getDisableData(allOPOtion)
      } catch (error) {
        console.error(error)
      }
    })
    const viewUseDealerFn = data => {
      if (data && data.loyaltyId) {
        let { loyaltyId = '', gsCode = '' } = data
        const patchParams = { orderId: data.orderId || '', sign: 'loyaltyCouponTypeList' }
        loyaltyId && gsCode && viewUseDealer({ loyaltyId, gsCode, useclick: false, ...patchParams })
      }
      // EWCouponType:延保 2: 保养套餐 3:礼包 5:NEV 6:易损件
      if (data && [EWCouponType, 2, 3, 5, 6].includes(data.couponType)) {
        let { id: productId = '', gsCode = '' } = data
        productId && gsCode && viewUseDealer({ productId, couponType: data.couponType, orderId: data.orderId, gsCode, useclick: false, sign: 'couponTypeList' })
      }
    }
    const viewContractFn = data => {
      if (data.couponType === EWCouponType) {
        let notification = {
          ..._.pick(data, ['contactName', 'maxPurchaseMile', 'notificationFile', 'notificationName']),
          fin: data.carInfo.fin,
          validPeriod: data.effectiveMonth,
          startDate: data.contractStartDate,
          endDate: data.effectiveMonth !== -1 && data.contractEndDate,
          sign: 'ewProduct',
          productType: data.productType
        }

        // 二手车延保
        if (data.productType === 'PRD_CATEGORY_7') {
          notification = {
            ...notification,
            maxPurchaseMile: notification.maxPurchaseMile == -1 ? '不限制' : notification.maxPurchaseMile,
            exceedMileStart: data.exceedMileStart || '0',
            sign: 'ewUsedCarProduct',
          productType: data.productType
          }
        }

        viewEWContractServiceDealFn(notification)
      } else {
        const { contactName, products } = data
        const notificationInfo = products && products.notificationInfo ? products.notificationInfo : {}
        const notification = {
          contactName,
          fin: notificationInfo.fin,
          productName: products.productSkuName,
          effectiveMonth: notificationInfo.effectiveMonth || products.effectiveMonth,
          notificationFile: notificationInfo.notificationFile,
          notificationName: notificationInfo.notificationName,
          day: notificationInfo.day,
          month: notificationInfo.month,
          year: notificationInfo.year
        }
        viewContractServiceDealFn(notification)
      }
    }
    return {
      ...toRefs(state),
      viewUseDealerFn,
      viewContractFn,
      useDealerRef,
      getEnableData,
      enablePlanList,
      isShowDivider1,
      getUsedData,
      usedList,
      isShowDivider2,
      getDisableData,
      disablePlanList,
      isShowDivider3,
      enableDataLenNum,
      usedDataLenNum,
      disableDataLenNum,
      showPopUp,
      contractData
    }
  }
}
</script>

<style lang="scss" scoped>
.van-tabs {
  background: #f5f5f5;
  position: absolute;
  padding-bottom: 50px;
  overflow: auto;

  :deep(.van-tab--active) {
    color: #3088c5;
  }

  :deep(.van-tabs__line) {
    background: #3088c5;
  }
}
</style>
